var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"suporte-button"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.goToWpp()}}},[_vm._v("Suporte Akdemica")])])}
var staticRenderFns = []

export { render, staticRenderFns }